export default __webpack_public_path__ + "static/media/pure-gas-banner.f7cc8b8e.jpg";